<template>
  <div>
    <div class="text-h5 font-weight-bold mb-4">{{channel.descricao}}</div>

    <div class="pa-5">
      <v-row>
        <v-col
          v-for="(image, indexImage) in channel.imagens"
          :key="indexImage"
          class="d-flex child-flex flex-wrap justify-space-around flex-grow-1 flex-shrink-0"
          style="min-width: 200px; max-width: 100%;"
          cols="4"
        >
          <v-card elevation="6">
            <v-img
              :src="image.image"
              :lazy-src="image.image"
              aspect-ratio="5"
              class="grey lighten-2"
            >
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="grey lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-card-title class="text-h6">
              <v-row>
                <v-col style="align-self: center;">
                    Ordem de exibição: {{indexImage + 1}}
                </v-col>
                <v-col class="text-center" style="align-self: center;" cols="4">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        dark
                        color="red"
                        v-bind="attrs"
                        v-on="on"
                        @click="handleDeleteImage(indexImage)"
                      >
                        <v-icon>
                          mdi-delete
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Remover Imagem</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="2" v-if="image.canal !== null && image.ordemExibicao !== null" class="pa-0">
                   <v-checkbox
                    
                    v-model="imagesToExclude"
                    :value="image"
                    color="#005a64"
                   >
                   </v-checkbox>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
          
        </v-col>
      </v-row>
    </div>

    <div class="pa-5">
      <div class="text-h6">Upload de Imagem</div>
      <v-row>
        <v-col cols="4">
          <v-file-input
            accept="image/*"
            color="#005a64"
            v-model="imageToUpload"
            label="Imagem"
            outlined
            dense
          ></v-file-input>
        </v-col>
        <v-col class="text-left">
          <v-btn dark color="primary" @click="uploadImage()">
            Incluir imagem
          </v-btn>
        </v-col>
        <v-col class="text-center">
          <v-tooltip bottom v-if="imagesToExclude.length > 0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                block
                color="red"
                class="mb-4"
                v-bind="attrs"
                v-on="on"
                @click="deleteSelectedBanners()"
              >
                Excluir Banners Selecionados
              </v-btn>
            </template>
            <span>Excluir todos os banners selecionados do canal</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                block
                color="#005a64"
                v-bind="attrs"
                v-on="on"
                @click="saveChannelBanners(channel)"
              >
                Salvar
              </v-btn>
            </template>
            <span>Salvar alterações do canal</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>

    <v-divider class="mt-2 mb-2" />

    <!-- Dialog -->
    <!-- Success -->
    <v-dialog v-model="success.active" persistent width="400">
      <v-card>
        <v-card-title class="text-h5" style="background: #005a64; color: white;" v-html="success.title"></v-card-title>
        <div class="pa-7" v-html="success.message"></div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#005a64" text @click="success.action">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Confirm -->
    <v-dialog v-model="confirm.active" persistent width="400">
      <v-card>
        <v-card-title class="text-h5" style="background: #005a64; color: white;" v-html="confirm.title"></v-card-title>
        <div class="pa-7" v-html="confirm.message"></div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#005a64" text @click="confirm.active = false">CANCELAR</v-btn>
          <v-btn color="#005a64" text @click="confirm.action">SIM</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      imageToUpload: null,
      imagesToRemove: [],
      success: {
        title: null,
        active: false,
        message: null,
        action: null
      },
      confirm: {
        title: null,
        active: false,
        message: null,
        action: null
      },
      imagesToExclude: [],
    };
  },

  props: {
    channel: Object,
    token: String,
  },

  created() {
    
  },

  methods: {
    async saveChannelBanners(channel) {
      // Exibe o loading
      this.$parent.$parent.loading.message = "Atualizando banners! Aguarde...";
      this.$parent.$parent.loading.active = true;

      let listErrors = [];
      let listSuccess = [];

      let haveImagesToSave = false;

      for (let i in channel.imagens) {
        try {
          if (channel.imagens[i].canal === null && channel.imagens[i].ordemExibicao === null) {
            haveImagesToSave = true;
            let response = await axios.post(
              `https://www.leverosintegra.com.br/map/Api/SolarBanners?token=${this._props.token}`,
              {
                canal: channel.canal,
                descricao: channel.descricao,
                imagens: [channel.imagens[i]]
              }
            )

            // Valida o retorno da requisição
            if (response.status === 200) {
              listSuccess.push(channel.imagens[i].name)
            } else {
              listErrors.push(channel.imagens[i].name)
            }
          }
        } catch {
          listErrors.push(channel.imagens[i].name)
        }
      }

      if (haveImagesToSave) {
        this.success.title = listErrors.length > 0 ? 'Atenção!' : 'Sucesso!';
        this.success.message = "";
        if (listSuccess.length > 0) {
          this.success.message = "Benners salvos com sucesso: <br/><ul>";
          listSuccess.forEach(el => {
            this.success.message += "<li>"+ el +"</li>"
          })
          this.success.message += "</ul></br>"
        }
  
        if (listErrors.length > 0) {
          this.success.message = "Benners com erros, por favor tente novamente: <br/><ul>";
          listErrors.forEach(el => {
            this.success.message += "<li>"+ el +"</li>"
          })
          this.success.message += "</ul>"
        }
        
        this.success.action = () => { window.location.reload() };
        this.success.active = true;
      }


      // Desativa o loader e ativa o dialog
      this.$parent.$parent.loading.active = false;
      
    },

    async uploadImage() {
      if (this.imageToUpload) {
        // Recupera o this
        let that = this;
        // Realiza a conversão do arquivo p/ Base64
        var reader = new FileReader();
        reader.readAsDataURL(this.imageToUpload);
        reader.onload = function () {
          that._props.channel.imagens.push({
            canal: null,
            image: reader.result,
            ordemExibicao: null,
            name: that.imageToUpload.name
          })
          that.imageToUpload = null;
        };
        reader.onerror = function (error) {
          console.log('Error: ', error);
        };
      }
    },

    deleteImage(indexImage) {
      // Insere imagens
      if (
        this.channel.imagens[indexImage].canal !== null &&
        this.channel.imagens[indexImage].ordemExibicao !== null
      ) {
        this.$parent.$parent.loading.message = "Removendo banner, aguarde...";
        this.$parent.$parent.loading.active = true;
        axios.post(
          `https://www.leverosintegra.com.br/map/Api/SolarBanners?token=${this._props.token}&confirmDelete=true`,
          [{
            canal: this.channel.imagens[indexImage].canal,
            ordemExibicao: this.channel.imagens[indexImage].ordemExibicao,
            image: null
          }]
        ).then(res => {
          if (res.status === 200) {
            this.$parent.$parent.loading.active = false;
            this.success.title = "Sucesso!";
            this.success.message = "Banner removido com sucesso";
            this.success.action = () => { window.location.reload() };
            this.success.active = true;
          }
        }).catch(err => {
          console.log(err)
          this.$parent.$parent.loading.active = false;
        })
      } else {
        // Exclui imagens temporárias
        this.channel.imagens.splice(indexImage, 1)
      }

    },

    handleDeleteImage(indexImage) {
      this.confirm.title = "Atenção!";
      this.confirm.message = "Deseja continuar com a exclusão do Banner?";
      this.confirm.action = () => { this.deleteImage(indexImage); this.confirm.active = false }
      this.confirm.active = true;
    },

    deleteSelectedBanners() {
      if (this.imagesToExclude.length > 0) {
        let tempImages = []
        this.imagesToExclude.forEach((el) => {
          tempImages.push({
            canal: el.canal,
            image: null,
            ordemExibicao: el.ordemExibicao
          })
        })

        this.$parent.$parent.loading.message = "Removendo banner, aguarde...";
        this.$parent.$parent.loading.active = true;
        axios.post(
          `https://www.leverosintegra.com.br/map/Api/SolarBanners?token=${this._props.token}&confirmDelete=true`,
          tempImages
        ).then(res => {
          if (res.status === 200) {
            this.$parent.$parent.loading.active = false;
            this.success.title = "Sucesso!";
            this.success.message = "Banner removido com sucesso";
            this.success.action = () => { window.location.reload() };
            this.success.active = true;
          }
        }).catch(err => {
          console.log(err)
          this.$parent.$parent.loading.active = false;
        })
      }
    }
  }

};
</script>

<style lang="scss" scoped>
.v-tooltip__content {
  opacity: 2!important;
  background: gray;
}
.documents {
  .container {
    max-width: 90%;
    margin: 0 auto;

    .header {
      display: flex;
      margin: 20px 0;

      button {
        background: var(--standardGreen);
        color: var(--white);
        border-radius: 5px;
        padding: 10px;
        width: 40%;
      }

      input {
        border-bottom: 1px solid var(--gray-500);
        outline: none;
        margin-left: 20px;
        color: var(--gray-500);
        width: 100%;
      }
    }

    .loader {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 80px;

      i {
        color: var(--blue);
        font-size: 4rem;
      }
    }

    .table {
      table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;

        thead {
          tr {
            th {
              background: var(--gray-70);
              padding: 5px;
            }
          }
        }

        tbody {
          tr {
            td {
              padding: 10px;
              border-bottom: 1px solid var(--gray-100);
              text-align: center;

              button {
                background: var(--gray-100);
                color: var(--gray-800);
                border-radius: 10px;
                padding: 5px;
                outline: none;
              }

              a {
                color: var(--darkGreen);
              }
            }
          }
        }
      }
    }
  }
}
</style>